import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Reveal, Eyebrow } from "../components/Reveal";

const FAQS = [
  {
    q: "What is metabolic medicine?",
    a: "Metabolic medicine focuses on how the body produces, stores and uses energy—and how disturbances in these processes contribute to concerns such as insulin resistance, diabetes, fatty liver, abnormal cholesterol and weight gain.",
  },
  {
    q: "What is functional medicine?",
    a: "Functional medicine is an approach that examines patterns across systems—nutrition, movement, sleep, stress and environment—alongside conventional clinical assessment. At InSight Metabolics it is practised within a physician-led, evidence-informed framework.",
  },
  {
    q: "Is everyone eligible for functional medicine treatment?",
    a: "No. We assess every person individually and offer treatment only where we believe they genuinely fall within a category that can benefit from our treatment protocol. Acute conditions are ideally treated under conventional medicine.",
  },
  {
    q: "Are consultations conducted online?",
    a: "Yes. All consultations are conducted virtually through a secure video consultation, allowing you to meet Dr Dikshit from wherever you are.",
  },
  {
    q: "Can I consult if I already have a doctor?",
    a: "Absolutely. Our work is complementary to your existing medical care. We are happy to consider the advice of your treating physicians and do not recommend stopping prescribed medication without appropriate medical supervision.",
  },
  {
    q: "Do I need blood tests before my consultation?",
    a: "No. Recent reports are helpful if you have them, but they are not required to begin. Where appropriate, investigations may be suggested after your initial consultation.",
  },
  {
    q: "Can you review my existing reports?",
    a: "Yes. Reviewing previous investigations and laboratory reports is a routine part of understanding your health patterns before and during your consultation.",
  },
  {
    q: "Will I be prescribed supplements?",
    a: "Only where clinically appropriate. We do not believe everyone needs dozens of supplements—recommendations are individualised, and sometimes the right answer is simpler.",
  },
  {
    q: "Can lifestyle changes be personalised around my work and family life?",
    a: "Yes. A plan only works if it works in real life. Nutrition, movement, sleep and stress strategies are built around your actual routine, responsibilities and preferences.",
  },
  {
    q: "How does follow-up work?",
    a: "Follow-up consultations review your symptoms, adherence, laboratory trends and measurable outcomes, and the plan is adjusted over time. The aim is steady, sustainable progress—not a short-term protocol.",
  },
];

export const Faq = () => (
  <section id="faq" className="bg-ivory grain relative" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-20 lg:py-32">
      <Reveal className="text-center">
        <Eyebrow>10 · Questions</Eyebrow>
        <h2 className="mt-6 font-serif font-medium text-forest text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
          Frequently asked questions
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-line" data-testid={`faq-accordion-item-${i}`}>
              <AccordionTrigger className="text-left font-serif text-lg sm:text-xl text-ink hover:text-forest hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-inkmuted leading-relaxed text-[15px] pb-6 max-w-2xl">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
